<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refProductCost'
        :data-source='productSalesPriceInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="완제품코드"
        :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing'
        @cell-prepared="onCellPrepared"
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="완제품원가내역"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          width="80"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품번"
          data-field="완제품코드"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
       <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          width='80'

        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
          width='120'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          width='80'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="판매가 기준정보"
          alignment='center'
        >
          <DxColumn
            caption="판매가적용일"
            :allowEditing='false'
            data-field="판매가기준일자"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="판매가"
            data-field="기준판매가"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩가"
            data-field="기준스크랩가"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="판매가공비"
            data-field="판매가공비"
            :visible='true'
            dataType="number"
            format='#,##0.000'
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :caption="getSelectedDate()"
          alignment='center'
        >
          <DxColumn
            :allowEditing="true"
            caption="스크랩가격"
            data-field="현스크랩가"
            :visible='true'
            dataType="number"
            format='#,##0.00'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="변동재료비"
            data-field="변동재료비"
            :visible='true'
            dataType="number"
            format='#,##0.000'
          >
          </DxColumn>
          <DxColumn
            caption="현판매가기준일"
            :allowEditing='false'
            data-field="현판매가적용일자"
            dataType= 'date'
            format='yyyy-MM-dd'
            alignment='center'>
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="등록판매가(A)"
            data-field="현판매가"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="산출판매가(B)"
            data-field="산출판매가"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="차이(A-B)"
            data-field="판매가차이"
            :visible='true'
            dataType="number"
            format='#,##0'
            sort-order="asc"
          >
          </DxColumn>
        </DxColumn>
        <DxMasterDetail
          :enabled="true"
          template="salesPriceDetailTemplate"
        />
        <template #salesPriceDetailTemplate="{ data: item }">
          <ProductSalesPriceDetailTemp :item=item :baseDate="today" @refresh-detail-completed="onRefreshDetailCompleted"/>
        </template>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <DxPopupGen
        :visible.sync="popupPriceFromExcel"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="400"
        :height="250"
        title="판매가 일괄등록"
      >
        <dx-data-grid ref='refProductPriceInfoListSample'
          :data-source='productPriceInfoListSample'
          :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
          :hover-state-enabled = "true" :allowColumnResizing = 'true'
          column-resizing-mode = 'widget' :allow-column-reordering = "true"
          :row-alternation-enabled="true"
          :focused-row-enabled="false"
          :auto-navigate-to-focused-row="false"
          @toolbar-preparing='onToolbarPreparingRegPrice'
        >
          <DxExport
            :enabled="false"
            file-name="판매가일괄등록"
          />
          <DxColumn
            :allowEditing='true'
            caption="기준일"
            data-field="적용일자"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='false'
            caption="자체품번"
            data-field="품번"
          >
          </DxColumn>
          <DxColumn
            :allowEditing='true'
            caption="납품가"
            data-field="가격"
            format='#,##0'
            dataType="number"
          >
          </DxColumn>
          <dx-paging :enabled="false"/>
          <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
          <dx-sorting mode="multiple"/>
        </dx-data-grid>
      </DxPopupGen>
      <input id="batch-detail-input" type="file" @change="confirmRegColiPrice($event)" accept=".xlsx" style='display: none;'>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxMasterDetail,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'
import ProductSalesPriceDetailTemp from './ProductSalesPriceDetailTemp'
import DxTabPanel from 'devextreme-vue/tab-panel'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import ExcelJS from 'exceljs'

export default {
  name: 'ProductMaterialCost',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '판매가 변동관리'
        }
      ],
      productSalesPriceInfo: null,
      focusedRowKey: null,
      itemTypeLookup: null,
      meterialTypeLookup: null,
      processingTypeLookup: null,
      selectedRow: null,
      productSalesPriceInfoDetail: null,
      gridHeightTree: null,
      selectedRowBefore: 'init',
      today: AppLib.getToday(),
      scrapPrice: null,
      // popup salesprice batch reg
      popupPriceFromExcel: false,
      productPriceInfoListSample: [
        { 적용일자: 'text형식(2021-09-01)', 품번: 'sample', 가격: 0 }
      ]
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxTabPanel,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxMasterDetail,
    DxPopupGen,
    ProductSalesPriceDetailTemp
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshProductSalesPrice()
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcCostSum (row) {
      return (row.재료비소계 + row.도급비용)
    },
    getSelectedDate () {
      return `${this.today} 판매가 정보`
    },
    onCellPrepared (e) {
      if (e.rowType === 'data' && e.column.dataField === '판매가차이') {
        if (e.data.판매가차이 === null || e.data.판매가차이 > 0) {
          this.$Q(e.cellElement).css('background-color', '#ff7970')
        } else if (e.data.판매가차이 < 0) {
          this.$Q(e.cellElement).css('background-color', '#70d6ff')
        }
      }
    },
    onSelectionChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onRefreshDetailCompleted () {
      if (this.selectedRowBefore !== null) {
        this.$refs.refProductCost.instance.collapseRow(this.selectedRowBefore)
        this.selectedRowBefore = this.selectedRow.완제품코드
      }
      // this.$refs.refProductCost.instance.expandRow(this.focusedRowKey)
    },
    onToolbarPreparing (e) {
      if (this.regMode === false) return

      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.today,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.today = args.value
              this.refreshProductSalesPrice()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '판매가 일괄등록',
            icon: 'add',
            text: '판매가 일괄등록',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.popupPriceFromExcel = true
            }
          }
        }
      )
    },
    refreshProductSalesPrice () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllSalesPriceByCoilPrice', { 기준일: this.today })
        .then((data) => {
          this.isLoading = false
          this.productSalesPriceInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    // POPUP SALES PRICE BATCH REG
    confirmRegColiPrice: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      this.$snotify.confirm('판매가를 등록 하시겠습니까?', '', {
        timeout: 10000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          { text: '등록',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.regProductPrice()
            }
          },
          { text: '취소',
            action: (toast) => {
              this.$snotify.remove(toast.id)
              this.$Q('#batch-detail-input').val('')
            }
          }
        ]
      })
    },
    async regProductPrice () {
      this.isLoading = true
      let goodsInfoList = null
      await this.$_sp.runNoEncodeFindProc('spFindAllGoods', {})
        .then((data) => {
          goodsInfoList = this.$_sp.MakeModel(data)
          console.log(goodsInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
      let file = document.getElementById('batch-detail-input')['files'][0]
      this.$Q('#batch-detail-input').val('')
      let reader = new FileReader()
      let vm = this
      reader.onloadend = function (event) {
        // excel row cell array = 1 base
        let priceArray = []
        let arrayBuffer = reader.result
        const workbook = new ExcelJS.Workbook()
        workbook.xlsx.load(arrayBuffer).then(function (workbook) {
          const worksheet = workbook.worksheets[0]
          let row = null
          let isRowEmptyCount = 0
          for (let i = 2; ; i++) {
            row = worksheet.getRow(i)
            if (AppLib.getCellFromExcel(row, 1) === null || AppLib.getCellFromExcel(row, 1).length === 0) {
              isRowEmptyCount++
              if (isRowEmptyCount > 2) {
                console.log('index= ' + i)
                break
              }
              continue
            }
            isRowEmptyCount = 0

            // let temp = AppLib.replaceAll(AppLib.getCellFromExcel(row, 2), ' ', '')
            // temp = AppLib.replaceAll(temp, '-', '')
            // temp = AppLib.replaceAll(temp, '~', '')
            let temp = AppLib.getCellFromExcel(row, 2)
            if (temp !== null) {
              temp = temp.trim()
            }

            const autoNo = vm.$_.findWhere(goodsInfoList, { 품번: temp })
            if (autoNo === undefined) {
              continue
            }

            const where = vm.$_.findIndex(priceArray, { 품번: autoNo.품번 })
            if (where !== undefined && where.가격 !== 0) {
              console.log('Duplicate No = ' + autoNo.품번)
              continue
            }

            let param = {
              적용일자: AppLib.getCellFromExcel(row, 1),
              품번: autoNo.품번,
              가격: Math.round(parseFloat(AppLib.getCellFromExcel(row, 3)))
            }
            priceArray.push(param)
          }
          // console.log(priceArray)
          vm.$_sp.runInsertOrUpdayeSqlProc('가격정보_판매가', ['적용일자', '품번'], null, priceArray)
            .then((data) => {
              vm.isLoading = false
              vm.$snotify.info('등록 되었습니다.')
              vm.updateAllPriceLastDate()
            })
            .catch(error => {
              vm.isLoading = false
              if (error.response.status === ConstDef.GENERRAL_ERROR) {
                vm.$snotify.error('적용일 기준 등록된 품번(판매가)이 있습니다.')
              } else {
                vm.$snotify.error('적용일 기준 등록된 품번(판매가)이 있습니다.')
              }
            })
        })
      }
      reader.readAsArrayBuffer(file)
    },
    onToolbarPreparingRegPrice (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            hint: '엑셀파일 선택',
            icon: 'add',
            text: '파일선택',
            type: 'danger',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#batch-detail-input').click()
            }
          }
        },
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '입력양식 다운로드',
            icon: 'download',
            text: '등록양식 다운로드',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$refs.refProductPriceInfoListSample.instance.exportToExcel(false)
            }
          }
        }
      )
    },
    validateBaseDate (e) {
      if (this.productPriceInfoList.length === 0 || this.isEditDate === false) return true
      return this.$_.find(this.productPriceInfoList, function (item) { return item.적용일자 >= e.data.적용일자 }) === undefined
    },
    updateAllPriceLastDate () {
      this.$_sp.runUpdateProc('spUpdateAllPriceLastDate', [{ null: '' }])
        .then((data) => {
          this.popupPriceFromExcel = false
          this.refreshProductSalesPrice()
        })
    }
  }
}
</script>

<style lang="scss">
.ss{
  background-color: #70d6ff;
}
</style>
